// extracted by mini-css-extract-plugin
module.exports = {"loading_container":"PageLoader_loading_container__3zJij","ball_clip_rotate":"PageLoader_ball_clip_rotate___i0Tn","rotate":"PageLoader_rotate__HjpNv"};